﻿import { createAppStore } from '@store/createAppStore';

import { RoutingFlagModel } from './types';

export type RoutingFlagState = {
  isLoading: boolean;
  isError: boolean;
  loaded: boolean;
  flags: RoutingFlagModel[];
};

const initialState: RoutingFlagState = {
  isLoading: false,
  isError: false,
  loaded: false,
  flags: [],
};

export const [routingFlagStore, setRoutingFlagStore] =
  createAppStore<RoutingFlagState>(initialState, 'routingFlagStore');
